import { IconDefinition, IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import { useRouter } from "next/router";
import {
  faFacebook,
  faInstagram,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import { faMap } from "@fortawesome/pro-regular-svg-icons";

/* eslint-disable-next-line */
export interface LFooterProps {
  id?: string;
  leftText?: string;
  rightText?: string; //rich text
  column?: {
    title?: string;
    content?: string; //rich text
  }[];
  iconColumnTitle?: string;
  linkWithIcon?: {
    iconName?: string;
    text?: string;
    link?: string;
  }[];
  bottomContent?: string; //rich text
}

export function LFooter(props: LFooterProps) {
  const router = useRouter();

  const renderIcon = (iconName: string): IconDefinition => {
    switch (iconName) {
      case "facebook": {
        return faFacebook;
      }

      case "instagram": {
        return faInstagram;
      }

      case "tiktok": {
        return faTiktok;
      }

      case "maps": {
        return faMap;
      }

      default: {
        return faFacebook;
      }
    }
  };

  return (
    <div className="border-t bg-ekblue border-t-white/25" id={props?.id}>
      <div className="container px-4 py-5 mx-auto lg:text-auto lg:flex-row lg:max-w-7xl">
        <div className="flex flex-col gap-5 lg:flex-row">
          {props?.column?.map((column, index) => (
            <div key={index} className="text-white basis-full">
              <div className="mb-5 text-ekgreen">{column?.title}</div>
              {column?.content && (
                <div className="small-markdown white-markdown flex flex-col gap-2">
                  <ReactMarkdown>{column?.content}</ReactMarkdown>
                </div>
              )}
            </div>
          ))}
          <div className="text-white basis-full">
            <div className="mb-5 text-ekgreen">{props?.iconColumnTitle}</div>
            <div className="grid grid-cols-2 gap-4 justify-between w-20">
              {props?.linkWithIcon?.map((link, index) => (
                <div
                  key={index}
                  onClick={() => router?.push(link?.link ?? "")}
                  className="cursor-pointer"
                >
                  {link?.iconName && (
                    <FontAwesomeIcon
                      icon={renderIcon(link?.iconName)}
                      className="w-5 h-5"
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between w-full mt-10 text-white/50">
          {props?.leftText && <div>{props?.leftText}</div>}

          {props?.rightText && (
            <div className="white-markdown">
              <ReactMarkdown>{props?.rightText}</ReactMarkdown>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LFooter;
